import React from 'react'
import Header  from '../../components/Header'
// import { Modal, Button } from 'antd-mobile';
import './album.less'
import { cateList } from '../../api/album'
import headsetImg from '../../images/headset.png'
import timeImg from '../../images/playtime.png'
import nowplayImg from '../../images/nowplay_icon.png'
import { getUrl } from '../../utils/deciphering'

// import lastplayImg from '../../images/nowplay_icon.png'

export default class ActivityAlbum extends React.Component{
  constructor(props) {
      super(props);
      this.state = {
        cateId: this.props.match.params.id,
        cateItem: {},
        stories: [],
        currentMusic: {}
      };
    }

  componentDidMount(){
    this.requestList()
    // let _this = this
    // document.addEventListener('touchstart', function () {
    //     let audio = audio = _this.refs.audio;
    //     if (audio) {
    //       audio.play();
    //     }
    // });
  }

  requestList = ()=>{
    cateList({
      cate_id: this.state.cateId
    }).then((res)=>{
      this.setState({
        cateItem: res,
        stories: res.story,
        currentMusic: this.decryptFilename(res.story[0])
      })

      let audio = this.refs.audio;
      audio.autoplay = true
    })
  }

  /**
   * 选择不同的故事
   */
  handleSelectStory = (storyKey) => {
    let currentMusic = this.decryptFilename(this.state.stories[storyKey])
    let audio = this.refs.audio
    this.setState({
      currentMusic: currentMusic
    },function() {
      audio.src = currentMusic.filename
      audio.play()
    })
  }

  decryptFilename = (story) => {
    let newStory = JSON.parse(JSON.stringify(story)); //深拷贝

    if (newStory.filename.indexOf('http') !== 0) {
      newStory.filename = getUrl(newStory.filename)
    }
    return newStory
  }

  download = () => {
    window.location.href = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.saker.app.huhu&ckey=CK1404130488352'
  }

  render() {
    let { cateItem, stories, currentMusic } = this.state
    return (
      <div className="activity-album-cate-container">
        <Header name ={ cateItem.name }  appIsShow={1} />
        <div className="carrier-cate-header">
          <span className="title">更新至{cateItem.story_new_num}集，共{cateItem.story_num}集</span>
          <div className="bg-img"><img src={cateItem.image} alt="" /></div>
        </div>
        <ul className="story-list">
          {
            stories.length > 0 ?
            stories.map((story,i) => (
            <li className="story-item" key={i} onClick={() => this.handleSelectStory(i)}>
              <div className="story-item-left">
                {
                  (currentMusic && currentMusic.id === story.id) ?
                  <img src={nowplayImg} alt="" /> : ''
                }
              </div>
                <div className="container">
                  <div className="story-img"><img src={story.image} alt="" /></div>
                  <div className="content">
                      <span>{ story.title }</span>
                      <div className="introduction">
                        <img src={headsetImg} alt="" />
                        <span>{ story.view_num }</span>
                        <img src={timeImg} alt="" />
                        <span>{ story.duration }</span>
                      </div>
                  </div>
                </div>
              </li>
          )) : ''
          }
        </ul>
        <audio src={ (currentMusic && currentMusic.filename && currentMusic.filename.length > 0) ? currentMusic.filename : ' '} ref="audio"></audio>

        <div style={{height:'3.125rem'}}></div>
        <div className="download-button" onClick={this.download}>
          下载收听更多精品故事
        </div>
      </div>
    );
  }
}